// assets/product-anchors.js
(function () {
  function getHeaderOffset() {
    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('.section-header') ||
      document.querySelector('#shopify-section-header');

    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    return Math.round(rect.height || header.offsetHeight || 0);
  }

  function scrollToId(id, smooth) {
    const target = document.getElementById(id);
    if (!target) return false;

    const headerH = getHeaderOffset();
    const extra = 16;

    const y =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      headerH -
      extra;

    window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }

  // Klicks in der Produkt-Navi abfangen
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a.product-section-nav__link[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute('href');
    if (!hash || hash.length < 2) return;

    const id = decodeURIComponent(hash.slice(1));

    if (document.getElementById(id)) {
      e.preventDefault();
      scrollToId(id, true);
      history.replaceState(null, '', '#' + encodeURIComponent(id));
    }
  });

  function scrollFromHash(smooth) {
    if (!location.hash || location.hash.length < 2) return;
    const id = decodeURIComponent(location.hash.slice(1));
    scrollToId(id, smooth);
  }

  // Wenn Seite mit Hash geladen wird (Theme Editor zuverlässig)
  document.addEventListener('DOMContentLoaded', function () {
    scrollFromHash(false);
  });

  window.addEventListener('load', function () {
    scrollFromHash(false);
  });
})();